import { Option } from 'funfix-core';
import { List } from 'immutable';
import { ERROR_APPEARANCE, makeFlag, makeFlagDescription } from '../records/Flag';
import { getErrorDetails } from '../utils/request-utils';
export const ADD_FLAG = 'FLAGS_ADD_FLAG';
export const REMOVE_FLAG = 'FLAGS_REMOVE_FLAG';
export function addFlag(options) {
  return {
    type: ADD_FLAG,
    flag: options.flag
  };
}
export function addCaasErrorFlag(options) {
  const errorDetails = getErrorDetails(options.message, options.hostConfig);
  const errorTID = errorDetails.tid ? "TID: ".concat(errorDetails.tid, " ") : '';
  const errorType = errorDetails.type ? "Type: ".concat(errorDetails.type) : '';
  const secondaryDescription = errorDetails.translation.showTID ? errorTID + errorType : undefined;
  return addFlag({
    flag: makeFlag({
      key: options.key,
      title: errorDetails.translation.title,
      description: makeFlagDescription({
        primary: errorDetails.translation.description,
        secondary: secondaryDescription
      }),
      actions: Option.of(options.actions).getOrElse(List()),
      appearance: ERROR_APPEARANCE
    })
  });
}
export function removeFlag(key) {
  return {
    type: REMOVE_FLAG,
    key
  };
}